import FieldDefs from './AdKeysFieldDefs'
import {doLangFields, isGoogleGny} from '../../lib/ks-tools'
import AdKeysGny from "./AdKeysGny";
import {Listeners} from "keysso/constants/listeners";
import Months from "../ads/mixins/Months";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    mixins: [Months],
    props: {
        db: {
            type: String,
            required: true,
        },
        domain: {
            type: String,
            required: true,
        },
    },
    data () {
        return {
            apiPath: '/report/simple/context/keywords',
            fields: doLangFields(this, "lang.report.adkeys", isGoogleGny() ? AdKeysGny : FieldDefs),
            sortOrder: [
                {
                    field: window.report_db.engine === "yandex" ? 'wsk' : 'ws',
                    direction: 'desc'
                },
            ],
            additionalActions: [
                {
                    label: this.$t("lang.report.open_uniq_tools"),
                    icon: ["fa", "fa-object-ungroup"],
                    event: function(){

                        if (this.$parent.$parent.$refs.ksTable.demoTariffModal.show) {
                            this.$parent.$parent.$refs.ksTable.demoTariffModal.message = this.$t('lang.modal.demoTariffNotAllowed')
                            this.$emitter.emit(Listeners.POPUP_KS_TABLE_DEMO_OPEN);
                            return
                        }

                        let vars = {};

                        this.$parent.$parent.$refs.ksTable.apiUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                            vars[key] = value;
                        });

                        vars['filter'] = this.getQuery();
                        vars['from'] = 'adkeywords';

                        window.open('/' + window.locale + '/tools/unique#' + Object.keys(vars).map(key => `${key}=${encodeURIComponent(vars[key])}`).join('&'), '_blank');
                    }
                },
                {
                    label: this.$t("lang.report.open_double_tools"),
                    icon: ["fa", "fa-trash-o"],
                    event: function() {
                        let vars = {};

                        this.$parent.$parent.$refs.ksTable.apiUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                            vars[key] = value;
                        });

                        vars['filter'] = this.getQuery();
                        vars['from'] = 'adkeywords';

                        window.open('/' + window.locale + '/tools/delete-double#' + Object.keys(vars).map(key => `${key}=${encodeURIComponent(vars[key])}`).join('&'), '_blank');
                    }
                },
            ],
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
